import { render } from "./DashboardEnrollees.vue?vue&type=template&id=7fb4caea"
import script from "./DashboardEnrollees.vue?vue&type=script&lang=js"
export * from "./DashboardEnrollees.vue?vue&type=script&lang=js"

import "./DashboardEnrollees.vue?vue&type=style&index=0&id=7fb4caea&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__